import React from 'react';
import { Box, Theme, withStyles } from '@material-ui/core';

export const WrapperBox = withStyles(({ spacing, palette }: Theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: palette.grey[100],
    borderRadius: 6,
    padding: spacing(0.5, 2),
    marginBottom: spacing(1.5),
  },
}))((props) => <Box {...props} />);

export const BankHeaderBox = withStyles(({ spacing, breakpoints }: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    marginRight: spacing(2),
    padding: spacing(1, 0),
    width: '100%',
    [breakpoints.up('sm')]: {
      padding: 0,
      width: 'auto',
    },
  },
}))((props) => <Box {...props} />);
